import React, { useEffect, useState } from "react"
import { Container, Box, Typography, CircularProgress } from "@mui/material"
import { useTranslation } from "react-i18next"
import PropTypes from "prop-types"

import ShippingTable from "./shippingtable"
import { getOrdersbystatus } from "helpers/api_helper"
import MuiPageHeader from "components/mui/MuiPageHeader"

const ShippingList = ({ embedded = false }) => {
  const { t } = useTranslation()
  const [filteredOrders, setFilteredOrders] = useState([])
  const [loading, setLoading] = useState(true)

  if (!embedded) {
    document.title = t("Shipping") + " | FlexFlow ERP"
  }

  useEffect(() => {
    getOrdersbystatus("INVOICED").then((res) => {
      setFilteredOrders(res)
      setLoading(false)
    })
  }, [])

  const breadcrumbs = [
    { label: t("Orders"), path: "/orders" },
    { label: t("Shipping") },
  ]

  const handleRefreshOrders = () => {
    setFilteredOrders([])
    setLoading(true)
    getOrdersbystatus("INVOICED").then((res) => {
      setFilteredOrders(res)
      setLoading(false)
    })
  }

  // When embedded (inside productionOverview), render without extra container/header
  if (embedded) {
    return (
      <Box>
        {loading ? (
          <Box sx={{ display: "flex", flexDirection: "column", alignItems: "center", py: 4 }}>
            <CircularProgress color="primary" size={48} />
            <Typography variant="body2" color="text.secondary" sx={{ mt: 2 }}>
              {t("Loading Shipping Orders")}...
            </Typography>
          </Box>
        ) : (
          <ShippingTable
            onUpdateSelectedOrders={handleRefreshOrders}
            orders={filteredOrders}
          />
        )}
      </Box>
    )
  }

  // Standalone mode (accessed via /shipping route)
  return (
    <Box sx={{ py: 1, minHeight: "100vh" }}>
      <Container maxWidth={false}>
        <MuiPageHeader
          title={t("Shipping")}
          subtitle={t("Manage shipping for invoiced orders")}
          breadcrumbs={breadcrumbs}
        />

        {loading ? (
          <Box sx={{ display: "flex", flexDirection: "column", alignItems: "center", py: 8 }}>
            <CircularProgress color="primary" size={48} />
            <Typography variant="body2" color="text.secondary" sx={{ mt: 2 }}>
              {t("Loading Shipping Orders")}...
            </Typography>
          </Box>
        ) : (
          <ShippingTable
            onUpdateSelectedOrders={handleRefreshOrders}
            orders={filteredOrders}
          />
        )}
      </Container>
    </Box>
  )
}

ShippingList.propTypes = {
  embedded: PropTypes.bool,
}

export default ShippingList
